import React, { useEffect } from "react";

/**
 * Right-hand slide-over. The prototype closes on scrim click and stops
 * propagation on the panel; Escape-to-close is added because a keyboard user
 * otherwise has no way out (the design shows a mouse-only ✕).
 */
const Drawer = ({ onClose, narrow = false, labelledBy, children }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="admin-drawer-scrim" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className={`admin-drawer ${narrow ? "admin-drawer--narrow" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Drawer;
